(ns manage.campaign-insights-page.hooks
  (:require [common.localstorage :as localstorage]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :refer [adsets-query]]
            [manage.campaign-insights-page.view.charts :as charts]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-selected-adsets-channels []
  (let [{:keys [campaign-id]} (use-subscribe [:url-context])
        {adsets :data} (use-query (adsets-query {:campaign-id campaign-id}))
        selected-adset-ids (use-subscribe [:form.campaign-insights/value [:adset-ids]])]
    (-> adsets
        (cond->> (seq selected-adset-ids) (filter (comp (set selected-adset-ids) :id)))
        (->> (map :channel))
        set)))

(defhook use-selected-channel-adsets []
  (let [{:keys [campaign-id]} (use-subscribe [:url-context])
        {adsets :data} (use-query (adsets-query {:campaign-id campaign-id}))
        selected-channel (use-subscribe [:form.campaign-insights/value [:channel]])]
    (cond->> adsets
      (seq selected-channel) (filter (comp (partial = selected-channel) :channel)))))

(defhook use-adset-options []
  (let [adsets (use-selected-channel-adsets)]
    (->> adsets
         (remove :archived)
         (mapv (fn [{:keys [name id]}]
                 {:label name
                  :value id})))))

(defhook use-charts-data []
  {"impressions" (use-subscribe [:page.campaign-insights/impressions-clicks])
   "clicks" (use-subscribe [:page.campaign-insights/impressions-clicks])
   "top-variants-average-impressions" (use-subscribe [:page.campaign-insights/variant-average-impressions])
   "top-variants-average-clicks" (use-subscribe [:page.campaign-insights/variant-average-clicks])
   "top-variants-average-ctr" (use-subscribe [:page.campaign-insights/variant-average-ctr])
   "video-quartiles" (use-subscribe [:page.campaign-insights/video-quartiles])})

(defhook use-charts []
  (let [charts-data (use-charts-data)]
    (->> charts/charts
         ;; Only use charts that have data.
         (remove (fn [{:keys [id data-fn]
                       :or {data-fn identity}}]
                   (let [data (-> charts-data (get id) data-fn)]
                     (empty? data))))
         (into []))))

(defhook use-available-charts []
  (let [charts (use-charts)
        channels (use-selected-adsets-channels)]
    (->> charts
         ;; When only "ctv" channel adsets are selected,
         ;; the "clicks" graph should not be displayed
         (remove (fn [{:keys [id]}]
                   (and (= channels #{"ctv"})
                        (= id "clicks"))))
         (into []))))

(defhook use-ordered-charts []
  (let [available-charts (use-available-charts)
        [charts set-charts] (uix/use-state [])]
    (uix/use-effect (fn []
                      (let [chart-id-order (localstorage/get :campaign-insights-order)
                            chart-id->idx (into {} (map-indexed (fn [i e] [e i]) chart-id-order))
                            ordered-charts (->> available-charts
                                                (sort-by (comp chart-id->idx :id))
                                                (into []))]
                        (set-charts ordered-charts)))
                    [available-charts])
    {:charts charts
     :set-charts set-charts}))
